(ns frontend.ui.component.lp-portal.report.body.private-equity.holding.special-company.web.view
  (:require
   [clojure.string :as s]
   [common.time :as c-time]
   [frontend.ui.component.chart.view :as chart]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.company.financial-performance.view
    :refer [financial-performance-card]]
   [frontend.ui.component.lp-portal.report.company.financials-chart.view
    :refer [financials-chart]]
   [frontend.ui.component.lp-portal.report.company.net-debt-chart.view
    :refer [net-debt-chart-card]]
   [frontend.ui.component.lp-portal.report.company.overview.view
    :refer [overview-card]]
   [frontend.ui.component.lp-portal.report.company.value-chart.view
    :refer [valuation-card]]
   [frontend.ui.component.lp-portal.report.company.value-creation-card.view
    :refer [value-creation-plan-card]]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [frontend.ui.component.text-input.view :as text-input]
   [frontend.ui.component.checkbox.view :as checkbox]
   [frontend.ui.component.lp-portal.text-content.view :refer [rich-text-content]]
   [common.util :as cu]
   [common.localization :as loc]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.card.view :as card]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]))

(defn- optional-text-card
  [{:keys [rich-content rich-content-path
           rich-content-completed-at rich-content-completed-path
           heading-path heading-text
           enabled-path enabled?]
    :as   optional-section}
   {:keys [edit-mode? show-draft? save-text] :as props}]
  (when (or edit-mode? enabled?)
    [card
     {:title
      (when enabled? heading-text)}
     [:<>
      (when edit-mode?
        [:div
         [:span
          (loc/tr :custom-heading-in-use?)]
         [checkbox/checkbox
          {:checked?  enabled?
           :on-change (fn [check?]
                        (if check?
                          (do
                            (save-text heading-path (loc/tr :lp-report-custom-heading))
                            (save-text enabled-path "true"))
                          (save-text enabled-path nil)))}]
         (when enabled?
           [text-input/text-input
            {:type      "text"
             :value     (str heading-text)
             :on-change #(save-text heading-path (str %))}])])
      (when enabled?
        [rich-text-content
         {:html-content      rich-content
          :show-draft?       show-draft?
          :can-edit?         edit-mode?
          :completed-at      rich-content-completed-at
          :complete-changed! (when (and edit-mode?
                                        (fn? save-text))
                               (fn [new-content completed?]
                                 (save-text rich-content-path
                                            new-content
                                            rich-content-completed-path
                                            (if completed?
                                              ""
                                              (str (c-time/now-millis))))))
          :on-change         (when (and edit-mode?
                                        (fn? save-text))
                               #(save-text rich-content-path %))}])]]))

(defn enterprise-value-chart-card
  [enterprise-value props]
  [card
   {:title "Enterprise value waterfall"}
   [:<>
    [chart/chart enterprise-value props]
    (text-content/optional-footnote enterprise-value props)]])

(defn money-multiple-distribution-card
  [money-multiple-distribution props]
  [card
   {:title "Money multiple distribution"}
   [:<>
    [chart/chart money-multiple-distribution props]
    (text-content/optional-footnote money-multiple-distribution props)]])


(defn company-section
  [{:keys [holding-name
           overview
           financial-performance
           financials
           enterprise-value
           value-creation-plan
           optional-section
           valuation-text
           valuation
           money-multiple-distribution
           ownership]
    :as   ui-data}
   props]
  [section
   holding-name
   nil
   [:div
    [:div
     [overview-card overview props]]
    [grid/row {}
     [grid/column {:large 6}
      [financial-performance-card financial-performance props]]
     [grid/column {:large 6}
      [:div
       [financials-chart financials props]]]]
    [grid/row {}
     [grid/column {:large 12}
      [enterprise-value-chart-card enterprise-value props]]]
    [:div
     [value-creation-plan-card value-creation-plan props]]
    [free-text-card/optional-text-card optional-section props]
    [grid/row {}
     [grid/column {:large 6}
      [free-text-card/view "Valuation principles" valuation-text props]]
     [grid/column {:large 6}
      [money-multiple-distribution-card money-multiple-distribution props]
      #_[valuation-card valuation props]
     ]]
    [grid/row {}
     [grid/column {}
      [tabular-card/dynamic-table "Ownership" ownership props]]]]])

(defn company
  [{:keys [holding-ui-data] :as props}]
  [:div
   {:id (str "holding-report-" (:report-id holding-ui-data))}
   [:div
    [company-section holding-ui-data props]]])
